import type { UserInformationField } from "@circle-react-shared/ProfileFields/FormFields/UserInformation/UserInformation";
import { UserInformation } from "@circle-react-shared/ProfileFields/FormFields/UserInformation/UserInformation";
import { Section } from "./Section";

interface ProfileFieldsListProps {
  profileFields: {
    visible: UserInformationField[];
    not_visible: UserInformationField[];
  };
}

export const ProfileFieldsList = ({
  profileFields,
}: ProfileFieldsListProps) => {
  const { visible, not_visible: hidden } = profileFields;
  return (
    <Section dataTestId="profile-fields-section">
      <UserInformation fields={visible} />
      <UserInformation fields={hidden} isHidden />
    </Section>
  );
};
